var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { ASK_LUBAV_BUTTON_ENDPOINTS, } from '@backrs_ui/common-ui/src/models/nugget';
import { AskLubavButtonGroup, } from '@backrs_ui/common-ui/src/molecules/AskLubavButtons/AskLubavButtonGroup';
import { Box } from '@mui/material';
import { BackrsAssessment } from './BackrsAssessment';
import { QuickLook } from './QuickLook';
var INTERNSHIP_STRINGS = appStrings.modules.nugget.internship;
export function NuggetInternshipLarge(_a) {
    var _b, _c, _d, _e, _f, _g;
    var internshipInfo = _a.internshipInfo, askLubavButtonGroupProps = _a.askLubavButtonGroupProps, apiKeyOnClick = _a.apiKeyOnClick, askLubavButtonResponse = _a.askLubavButtonResponse;
    var _h = useState(true), isLogoLinkValid = _h[0], setIsLogoLinkValid = _h[1];
    var buttonConfigs = new Map([
        [
            ASK_LUBAV_BUTTON_ENDPOINTS.INTERNSHIP_AM_I_A_GOOD_FIT,
            {
                buttonTitle: INTERNSHIP_STRINGS.askLubav.amIAGoodFit,
                disabledInProd: true,
                requirements: {
                    requiresResume: true,
                },
                onClick: (_b = apiKeyOnClick === null || apiKeyOnClick === void 0 ? void 0 : apiKeyOnClick.find(function (x) { return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.INTERNSHIP_AM_I_A_GOOD_FIT; })) === null || _b === void 0 ? void 0 : _b.onClick,
                actionButtonText: (_c = apiKeyOnClick === null || apiKeyOnClick === void 0 ? void 0 : apiKeyOnClick.find(function (x) { return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.INTERNSHIP_AM_I_A_GOOD_FIT; })) === null || _c === void 0 ? void 0 : _c.actionButtonText,
            },
        ],
        [
            ASK_LUBAV_BUTTON_ENDPOINTS.INTERNSHIP_SIMILAR_ROLES,
            {
                buttonTitle: INTERNSHIP_STRINGS.askLubav.similarRoles,
                disabledInProd: true,
                onClick: (_d = apiKeyOnClick === null || apiKeyOnClick === void 0 ? void 0 : apiKeyOnClick.find(function (x) { return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.INTERNSHIP_SIMILAR_ROLES; })) === null || _d === void 0 ? void 0 : _d.onClick,
                actionButtonText: (_e = apiKeyOnClick === null || apiKeyOnClick === void 0 ? void 0 : apiKeyOnClick.find(function (x) { return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.INTERNSHIP_SIMILAR_ROLES; })) === null || _e === void 0 ? void 0 : _e.actionButtonText,
            },
        ],
        [
            ASK_LUBAV_BUTTON_ENDPOINTS.INTERNSHIP_INCREASE_MY_ODDS,
            {
                buttonTitle: INTERNSHIP_STRINGS.askLubav.increaseMyOdds,
                disabledInProd: true,
                requirements: {
                    requiresResume: true,
                },
                onClick: (_f = apiKeyOnClick === null || apiKeyOnClick === void 0 ? void 0 : apiKeyOnClick.find(function (x) { return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.INTERNSHIP_INCREASE_MY_ODDS; })) === null || _f === void 0 ? void 0 : _f.onClick,
                actionButtonText: (_g = apiKeyOnClick === null || apiKeyOnClick === void 0 ? void 0 : apiKeyOnClick.find(function (x) { return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.INTERNSHIP_INCREASE_MY_ODDS; })) === null || _g === void 0 ? void 0 : _g.actionButtonText,
            },
        ],
    ]);
    return (_jsxs(Box, { sx: largeInternshipContainerStyle, children: [askLubavButtonGroupProps && (_jsx(AskLubavButtonGroup, __assign({ buttonConfigs: buttonConfigs }, askLubavButtonGroupProps, { askLubavButtonResponse: askLubavButtonResponse }))), internshipInfo.ai_description, _jsxs(Box, { sx: textContainerStyle, children: [_jsx(QuickLook, { internshipInfo: internshipInfo }), _jsx(BackrsAssessment, {})] }), internshipInfo.logo_link && isLogoLinkValid && (_jsx(Box, { component: "img", src: internshipInfo.logo_link, alt: "Internship", sx: logoImageStyle, onError: function () { return setIsLogoLinkValid(false); } }))] }));
}
var largeInternshipContainerStyle = {
    mt: 3,
    gap: 2,
    display: 'flex',
    flexDirection: 'column',
};
var textContainerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 11fr)',
    mt: 3,
    gap: 2,
};
var logoImageStyle = {
    maxWidth: '100px',
    minWidth: '100px',
    maxHeight: '100px',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    alignSelf: 'flex-end',
    mt: 0,
    ml: 4,
};
